import validate from 'validate.js';

export const icsValidation = (value, textField) => {
  const validateUrl = validate.single(value, { url: true });
  if ('calendarUrl' === textField && (validateUrl && "string" === typeof validateUrl[0])) {
    return false;
  }
  if ('calendarUrl' === textField && (undefined === validateUrl && (!value.includes('.ics') && !value.includes('ical')))) {
    return false;
  }
  return true;
};
